import React from 'react';

const Logo = ({ className = '', size = 'md', showText = true }) => {
  const sizeClasses = {
    sm: 'h-8',
    md: 'h-10',
    lg: 'h-12',
    xl: 'h-16'
  };

  const textSizeClasses = {
    sm: 'text-lg',
    md: 'text-xl',
    lg: 'text-2xl',
    xl: 'text-3xl'
  };

  return (
    <div className={`flex items-center space-x-3 ${className}`}>
      <img 
        src="/logo.jpg" 
        alt="AvdCare Logo" 
        className={`${sizeClasses[size]} w-auto object-contain`}
      />
      {showText && (
        <div>
          <h2 className={`${textSizeClasses[size]} font-bold text-gray-900 font-alata`}>
            AvdCare
          </h2>
        </div>
      )}
    </div>
  );
};

export default Logo;
